// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./ArrowButton.assets/ArrowButton.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*  imported from ArrowButton.module.scss  */
.ArrowButton-module-Root_2-0 {
  position: absolute;
  z-index: 5;
  top: 50%;
  width: 44px;
  height: 44px;
  cursor: pointer;
  user-select: none;
  outline: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  transition: transform 0.1s ease-in-out; }

.ArrowButton-module-Root_2-0::before,
.ArrowButton-module-Root_2-0::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  content: ''; }

.ArrowButton-module-Root_2-0::before {
  width: 38px;
  height: 38px;
  border-radius: 38px;
  background-color: #fff;
  box-shadow: 0 0 0 1px rgba(13, 35, 67, 0.06), 0 5px 15px -4px rgba(13, 35, 67, 0.4);
  transition: box-shadow 0.1s ease-in-out; }

.ArrowButton-module-Root_2-0::after {
  background: no-repeat 50% 50% url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.ArrowButton-module-Root_2-0:hover::before {
  box-shadow: 0 0 0 1px rgba(13, 35, 67, 0.06), 0 10px 20px -4px rgba(13, 35, 67, 0.36); }

.ArrowButton-module-Root_2-0:active::before,
.ArrowButton-module-Root_2-0:active:hover::before {
  box-shadow: 0 0 0 1px rgba(13, 35, 67, 0.06), 0 5px 15px -4px rgba(13, 35, 67, 0.4); }

.ArrowButton-module-hidden_3OR {
  display: none; }

.ArrowButton-module-direction_right_38G,
.ArrowButton-module-direction_right_38G:active,
.ArrowButton-module-direction_right_38G:active:hover {
  right: 0;
  transform: translate(50%, -50%); }

/* stylelint-disable-next-line no-descending-specificity */
.ArrowButton-module-direction_right_38G:hover {
  z-index: 10;
  /* в случае, когда 2 стрелки пересекаются, выводим наверх ту, на которую наведена мышка */
  transform: translate(50%, calc(-50% - 1px)); }

.ArrowButton-module-direction_left_1tU,
.ArrowButton-module-direction_left_1tU:active,
.ArrowButton-module-direction_left_1tU:active:hover {
  left: 0;
  transform: translate(-50%, -50%); }

/* stylelint-disable-next-line no-descending-specificity */
.ArrowButton-module-direction_left_1tU:hover {
  z-index: 10;
  /* в случае, когда 2 стрелки пересекаются, выводим наверх ту, на которую наведена мышка */
  transform: translate(-50%, calc(-50% - 1px)); }

.ArrowButton-module-direction_left_1tU::after {
  transform: rotate(180deg); }

/**
 * Анимация transform в FF выглядит плохо
 * https://stackoverflow.com/questions/24854640/strange-pixel-shifting-jumping-in-firefox-with-css-transitions
 * https://bugzilla.mozilla.org/show_bug.cgi?id=739176
 */
@-moz-document url-prefix('') {
  .ArrowButton-module-Root_2-0 {
    transition: transform 0s; }
  .ArrowButton-module-Root_2-0::before {
    transition: box-shadow 0s; } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/_internal_/components/ArrowButton/ArrowButton.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,6CAA6C;EAC7C,sCAAsC,EAAE;;AAE1C;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,mFAAmF;EACnF,uCAAuC,EAAE;;AAE3C;EACE,qEAAyE,EAAE;;AAE7E;EACE,qFAAqF,EAAE;;AAEzF;;EAEE,mFAAmF,EAAE;;AAEvF;EACE,aAAa,EAAE;;AAEjB;;;EAGE,QAAQ;EACR,+BAA+B,EAAE;;AAEnC,0DAA0D;AAC1D;EACE,WAAW;EACX,yFAAyF;EACzF,2CAA2C,EAAE;;AAE/C;;;EAGE,OAAO;EACP,gCAAgC,EAAE;;AAEpC,0DAA0D;AAC1D;EACE,WAAW;EACX,yFAAyF;EACzF,4CAA4C,EAAE;;AAEhD;EACE,yBAAyB,EAAE;;AAE7B;;;;EAIE;AACF;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,yBAAyB,EAAE,EAAE","sourcesContent":["@charset \"UTF-8\";\n/*  imported from ArrowButton.module.scss  */\n.ArrowButton-module-Root_2-0 {\n  position: absolute;\n  z-index: 5;\n  top: 50%;\n  width: 44px;\n  height: 44px;\n  cursor: pointer;\n  user-select: none;\n  outline: 0;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  transition: transform 0.1s ease-in-out; }\n\n.ArrowButton-module-Root_2-0::before,\n.ArrowButton-module-Root_2-0::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  content: ''; }\n\n.ArrowButton-module-Root_2-0::before {\n  width: 38px;\n  height: 38px;\n  border-radius: 38px;\n  background-color: #fff;\n  box-shadow: 0 0 0 1px rgba(13, 35, 67, 0.06), 0 5px 15px -4px rgba(13, 35, 67, 0.4);\n  transition: box-shadow 0.1s ease-in-out; }\n\n.ArrowButton-module-Root_2-0::after {\n  background: no-repeat 50% 50% url(\"./ArrowButton.assets/ArrowButton.svg\"); }\n\n.ArrowButton-module-Root_2-0:hover::before {\n  box-shadow: 0 0 0 1px rgba(13, 35, 67, 0.06), 0 10px 20px -4px rgba(13, 35, 67, 0.36); }\n\n.ArrowButton-module-Root_2-0:active::before,\n.ArrowButton-module-Root_2-0:active:hover::before {\n  box-shadow: 0 0 0 1px rgba(13, 35, 67, 0.06), 0 5px 15px -4px rgba(13, 35, 67, 0.4); }\n\n.ArrowButton-module-hidden_3OR {\n  display: none; }\n\n.ArrowButton-module-direction_right_38G,\n.ArrowButton-module-direction_right_38G:active,\n.ArrowButton-module-direction_right_38G:active:hover {\n  right: 0;\n  transform: translate(50%, -50%); }\n\n/* stylelint-disable-next-line no-descending-specificity */\n.ArrowButton-module-direction_right_38G:hover {\n  z-index: 10;\n  /* в случае, когда 2 стрелки пересекаются, выводим наверх ту, на которую наведена мышка */\n  transform: translate(50%, calc(-50% - 1px)); }\n\n.ArrowButton-module-direction_left_1tU,\n.ArrowButton-module-direction_left_1tU:active,\n.ArrowButton-module-direction_left_1tU:active:hover {\n  left: 0;\n  transform: translate(-50%, -50%); }\n\n/* stylelint-disable-next-line no-descending-specificity */\n.ArrowButton-module-direction_left_1tU:hover {\n  z-index: 10;\n  /* в случае, когда 2 стрелки пересекаются, выводим наверх ту, на которую наведена мышка */\n  transform: translate(-50%, calc(-50% - 1px)); }\n\n.ArrowButton-module-direction_left_1tU::after {\n  transform: rotate(180deg); }\n\n/**\n * Анимация transform в FF выглядит плохо\n * https://stackoverflow.com/questions/24854640/strange-pixel-shifting-jumping-in-firefox-with-css-transitions\n * https://bugzilla.mozilla.org/show_bug.cgi?id=739176\n */\n@-moz-document url-prefix('') {\n  .ArrowButton-module-Root_2-0 {\n    transition: transform 0s; }\n  .ArrowButton-module-Root_2-0::before {\n    transition: box-shadow 0s; } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
